module.exports = __webpack_public_path__ + "img/Group-228.f69e3f72.svg";